<template>
  <TopBarView
    v-if="authState && authState.isAuthenticated"
    :navigations="navigations"
    :path-level="1"
    :logo-route-definition="appRoutesDefinitions.dashboard"
    class="fixed z-50"
  ></TopBarView>
  <div class="pt-[64px]">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import { TopBarView } from '@/views';
import type { Navigation } from '@/models';
import { appRoutesDefinitions } from '@/routes-definitions';

const navigations: Navigation[] = [
  {
    label: 'Home',
    routeName: appRoutesDefinitions.dashboard.name,
    sourcePath: appRoutesDefinitions.dashboard.path,
    active: true
  },
  {
    label: 'Course Content Hub',
    routeName: appRoutesDefinitions.courseContentReview.name,
    sourcePath: appRoutesDefinitions.courseContentReview.path,
    active: false
  },
  {
    label: 'Video Services',
    routeName: appRoutesDefinitions.video.name,
    sourcePath: appRoutesDefinitions.video.path,
    active: false
  },
  {
    label: 'Text Services',
    routeName: appRoutesDefinitions.text.name,
    sourcePath: appRoutesDefinitions.text.path,
    active: false
  }
];
</script>
